// 工单概念了
import http from '../utils/request'

export default {
  // 工单筛选条件列表
  sheetParamsList(data) {
    return http.get('/pc/clientApi/sheet/sheetParamsList/' + data)
  },
  // 工单列表
  sheetList(data) {
    return http.get('/pc/clientApi/sheet/sheetList', { params: data })
  },
  // 获取我的工单列表
  mySheetList(data) {
    return http.get('/pc/clientApi/sheet/mySheetList', { params: data })
  },
  // 工单列表对应状态数量
  sheetListCount(data) {
    return http.get('/pc/clientApi/sheet/sheetListCount', { params: data })
  },
  // 撤销工单
  cancelSheet(data) {
    return http.post('/pc/clientApi/sheet/cancelSheet/' + data)
  },
  // 工单详情
  sheetDetail(data) {
    return http.get('/pc/clientApi/sheet/sheetDetail/' + data)
  },
  // 添加工单
  sheetAdd(data) {
    return http.post('/pc/clientApi/sheet/sheetAdd', data)
  },
  // 存为草稿
  sheetDraftAdd(data) {
    return http.post('/pc/clientApi/sheet/sheetDraftAdd', data)
  },
  // 问题系统列表
  questionSystemList() {
    return http.get('/pc/clientApi/sheet/questionSystemList')
  },
  // 验收工单
  sheetEvaluate(data) {
    return http.post('/pc/clientApi/sheet/sheetEvaluate', data)
  },
  // 验收不通过
  sheetEvaluateUnPass(data) {
    return http.post('/pc/clientApi/sheet/sheetEvaluateUnPass', data)
  },
  // 客户发起咨询
  sheetReplayManager(data) {
    return http.post('/pc/clientApi/sheet/sheetReplayManager', data)
  },
  // 工单操作日志
  sheetLogList(data) {
    return http.get('/pc/clientApi/sheet/sheetLogList/' + data)
  },
  // 工单追踪日志
  sheetFollowLogList(data) {
    return http.get('/pc/clientApi/sheet/sheetFollowLogList/' + data)
  },
  // 工单回复记录
  sheetReplayRecordList(data) {
    return http.get('/pc/clientApi/sheet/sheetReplayRecordList/' + data)
  },
  // 回复记录全部已读
  replayAllRead(data) {
    return http.post('/pc/clientApi/sheet/replayAllRead/' + data)
  },
  /** 获取草稿列表 */
  sheetDraftList(data) {
    return http.get('/pc/clientApi/sheet/sheetDraftList', { params: data })
  },
  /** 修改草稿 */
  sheetDraftEdit(data) {
    return http.post('/pc/clientApi/sheet/sheetDraftEdit', data)
  },
  /** 删除草稿 */
  deleteSheetDraft(data) {
    return http.post('/pc/clientApi/sheet/deleteSheetDraft/' + data)
  }
}
